const RESPONSIBILITY_VALUE_MAP = {
    MECHANICAL: '机械',
    ELECTRONIC_CONTROL: '电控',
    ALGORITHM: '算法'
};

const RESPONSIBILITIES = [
    {
        name: RESPONSIBILITY_VALUE_MAP.MECHANICAL,
        value: RESPONSIBILITY_VALUE_MAP.MECHANICAL,
        cn_name: RESPONSIBILITY_VALUE_MAP.MECHANICAL
    },
    {
        name: RESPONSIBILITY_VALUE_MAP.ELECTRONIC_CONTROL,
        value: RESPONSIBILITY_VALUE_MAP.ELECTRONIC_CONTROL,
        cn_name: RESPONSIBILITY_VALUE_MAP.ELECTRONIC_CONTROL
    },
    {
        name: RESPONSIBILITY_VALUE_MAP.ALGORITHM,
        value: RESPONSIBILITY_VALUE_MAP.ALGORITHM,
        cn_name: RESPONSIBILITY_VALUE_MAP.ALGORITHM
    }
];

export {
    RESPONSIBILITIES
};
